// app/javascript/controllers/toggle_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["switch", "track", "knob", "input"];
    static values = {
        defaultChecked: String
    }

    switch() {
        const isChecked = this.switchTarget.getAttribute("aria-checked") === "true";
        const newChecked = !isChecked;
        this.switchTarget.setAttribute("aria-checked", newChecked);

        if (newChecked) {
            // 开启状态
            this.trackTarget.classList.remove("bg-gray-700");
            this.trackTarget.classList.add("bg-indigo-500");
            this.knobTarget.classList.remove("translate-x-0", "bg-white");
            this.knobTarget.classList.add("translate-x-5", "bg-indigo-500");
            this.inputTarget.value = this.defaultCheckedValue;
            console.log(this.inputTarget.value);
        } else {
            // 关闭状态
            this.trackTarget.classList.remove("bg-indigo-500");
            this.trackTarget.classList.add("bg-gray-700");
            this.knobTarget.classList.remove("translate-x-5", "bg-indigo-500");
            this.knobTarget.classList.add("translate-x-0", "bg-white");
            this.inputTarget.value = "";
        }
        this.element.closest("form").requestSubmit();
    }
}
